<template>
  <Layout
    class="page-layout"
    @click.native="closeBox"
  >
    <input
      type="text"
      class="ainote-hidden-input"
    />
    <input
      type="password"
      class="ainote-hidden-input"
    />
    <top-nav
      v-if="meta.top"
      :meta="meta"
      :isTripartite="isTripartite"
      :isPrivate="isPrivate"
      ref="topNav"
    />
    <Layout class="page-home">
      <Layout
        v-if="meta.crumbs"
        class="contenBox crumbBox"
      >
        <bread-crumbs :isTripartite="isTripartite" />
      </Layout>
      <div
        v-if="meta.sider"
        class="contenBox"
      >
        <sider-nav-guild
          v-if="meta.siderType=='guild'"
          :isTripartite="isTripartite"
        />
        <Workbench-nav-guild
          v-else-if="meta.siderType=='workBench'"
          :isTripartite="isTripartite"
          :isPrivate="isPrivate"
        />
        <sider-nav v-else />
        <div class="pagebody rv1">
          <router-view />
        </div>
      </div>
      <Layout
        v-else
        class="page-content relative rv2"
      >
        <router-view />
      </Layout>
    </Layout>
    <Footer
      v-if="meta.footer"
      :isTripartite="isTripartite"
      :isPrivate="isPrivate"
    />
    <Modal
      v-model="modalShow"
      class="agreeMentModal"
      width="800px"
      :footer-hide="true"
      :mask-closable="false"
      :closable="false"
    >
      <iframe
        v-if='platformId === "xiaoyin"'
        src="/abk/static/xiaoyinNewUserAgreementModal.htm?v=20230228"
        width="768px"
        height="6000px"
        style="border:0px solid #ddd; margin-left:0px;margin-top: 20px;"
      ></iframe>
      <iframe
        v-else
        src="/abk/static/newUserAgreementModal.htm?v=20230228"
        width="768px"
        height="6000px"
        style="border:0px solid #ddd; margin-left:0px;margin-top: 20px;"
      ></iframe>
      <div class="foot">
        <div class="footButtom">
          <span
            class="cancelBtn"
            @click="cancel()"
          >取消</span>
          <span
            class="applyBtn"
            @click="agreeRules()"
          >我已阅读并同意</span>
        </div>
      </div>

    </Modal>
    <!-- <Modal
      v-model="hasNoPhone"
      :closable="false"
      :footer-hide="true"
      :mask-closable="false"
      :width="550"
    >
      <CompletePhone
        @cancelHandler="closeNoPhoneModal"
        v-if="hasNoPhone"
      />
    </Modal> -->
  </Layout>

</template>

<script>
import TopNav from './TopNav'
import SiderNav from './SiderNav'
import SiderNavGuild from './SiderNavGuild'
import Footer from './Footer'
import BreadCrumbs from './BreadCrumbs'
import WorkbenchNavGuild from './WorkbenchNavGuild'
// import CompletePhone from './CompletePhone'

import {
  getTheme,
  updateGuideStatus
} from 'http/api/default';

export default {
  name: 'Layout2',
  components: {
    TopNav,
    SiderNav,
    SiderNavGuild,
    Footer,
    BreadCrumbs,
    WorkbenchNavGuild,
    CompletePhone: () => import('./CompletePhone.vue')
  },
  data () {
    return {
      platformId: this.$store.state.app.platformId,
      hasNoPhone: false,
      meta: {},
      isTripartite: this.$store.state.app.isTripartite,
      isPrivate: this.$store.state.app.isPrivate,
      modalShow: false,
    }
  },
  provide: function () {
    return {
      getAgreeInfo: this.getAgreeInfo
    }
  },
  methods: {
    // 关闭弹窗
    closeNoPhoneModal () {
      this.hasNoPhone = false;
      localStorage.removeItem('hasNoPhoneFlag');
      location.reload();
    },

    // 验证当前账户 是否有绑定手机号 没有就弹窗
    hideNoPhoneModal () {
      this.hasNoPhone = false;
      localStorage.removeItem('hasNoPhoneFlag');
    },

    checkAccoutInfo () {
      fetch('/user/v4/domain/account/status/info')
        .then(response => response.json())
        .then(res => {
          // 需求0611：去除手机号绑定弹窗功能
          // if (res && res.data && !res.data.hasPhone && res.data.hasPhone !== undefined) {
          //   this.hasNoPhone = true;
          //   localStorage.setItem('hasNoPhoneFlag', true);
          // }
        })
        .catch(error => {
          console.error('Error:', error);
          if(localStorage.getItem('hasNoPhoneFlag') !== undefined) {
            localStorage.removeItem('hasNoPhoneFlag');
          }
        });
    },

    closeBox: function () {
      this.$refs['topNav'].closeSearchResult();
    },

    getTheme: function () {
      let timestamp = (new Date()).getTime();
      getTheme().then(function (res) {
        if (res.data.startTime < timestamp && res.data.endTime > timestamp) {
          document.getElementsByTagName('html')[0].setAttribute('class', 'gray');
        } else {
          // document.getElementsByTagName('html')[0].setAttribute('class', 'gray');
        }
      });
    },
    agreeRules () {
      updateGuideStatus(
        { "agreementAuth": 1 }
      ).then(res => {
        if (res.rt.status === 200) this.modalShow = false;
      })
    },
    cancel () {
      this.modalShow = false;
    },
    getAgreeInfo (value) {
      if (value === 1) { this.modalShow = false; console.log('ok') }
      else {
        this.modalShow = true
      }
    }
  },
  mounted () {
    // 如果有用户信息，直接跳到  首页
    if (this.$cookies.get('token') && !location.href.includes('/login') && !localStorage.hasNoPhoneFlag) {
      this.checkAccoutInfo();
    }
  },
  destroyed () {
    localStorage.removeItem('hasNoPhoneFlag');
  },
  watch: {
    $route (val) {
      this.meta = val.meta;
      // console.log(this.meta)
      // this.meta = this.$route.meta
      if (this.meta.title) {
        document.title = this.$t(this.meta.title)
        // document.querySelector('meta[name="keywords"]').setAttribute('content', this.meta.keywords)
        // document.querySelector('meta[name="description"]').setAttribute('content', this.meta.description)
      }
    }
  },
  created: function () {
    this.getTheme()
    this.meta = this.$route.meta;
    // console.log(this.meta)
    if (this.meta.title) {
      document.title = this.$t(this.meta.title)
      // document.querySelector('meta[name="keywords"]').setAttribute('content', this.meta.keywords)
      // document.querySelector('meta[name="description"]').setAttribute('content', this.meta.description)
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
.contenBox,
body {
  min-width: 1200px;
}

#app

.page-home {
  .crumbBox {
    flex: 0;
  }
}

@media screen and (max-width: 1919px) {
  .contenBox {
    width: 1200px;
    margin: 0 auto;
  }
}
@media screen and (min-width: 1919px) {
  .contenBox {
    width: 1600px;
  }
}
.contenBox {
  margin: 0 auto;
  position: relative;
  flex-direction: row;
  display: flex;
}
.body-column {
  background: #fff;
  flex-direction: row;
  margin-bottom: 20px;
}
.pagebody {
  border-left: 20px solid #f5f7f9;
  min-height: calc(100vh - 60px - 28px);
  background: #fff;
  flex: 1;
  flex-direction: row;
}
.cancelBtn {
  cursor: pointer;
}
.applyBtn {
  display: inline-block;

  padding: 0 15px;
  height: 32px;
  background: rgba(20, 203, 107, 1);
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  margin-left: 20px;
  cursor: pointer;
}
/*   .agreeMentModal{
    overflow: hidden;
  } */
/*   .foot{
    float: right;
  } */
.footButtom {
  margin-left: 75%;
}

.ainote-hidden-input {
  display: none;
  visibility: hidden;
  position: absolute;
  top: -500px;
}
</style>
